export function updateBeforeEditAction(state: any, payload: any) {
  return {
    ...state,
    data: {
      ...payload,
    },
  };
}
